const cartSections = [
  {
    type: 'cart-counter',
    selector: '[data-cart-counter]',
    callBack: function(){
        document.querySelectorAll('[data-cart-counter]')?.forEach(item => {
            const count = Number(item.textContent);
            if(count > 0){
                item.classList.remove('hidden');
            }else{
                item.classList.add('hidden');
            }
        });
    }
  },
  {
    type: 'cart-drawer',
    selector: '#cart-drawer'
  }
];

function getSectionsTypes()
{
    if(!Array.isArray(cartSections)){
        return '';
    }

    return cartSections.map(item => item.type).join(',')
}

class ProductVariants extends HTMLElement
{
    constructor()
    {
        super();

        this.options = [];

        this.view = this.dataset.view || 'select';

        this.productVariantSelectors = this.querySelectorAll('[data-product-variant-selector]');
        this.productJSONDataSelector = document.getElementById(`product_data_${this.dataset.productId}`);
        this.productJSONData = {};

        try{
            this.productJSONData = JSON.parse(this.productJSONDataSelector.innerText);
        }catch{
            console.error(`Product ${this.dataset.productId} invalid json data`, this.productJSONDataSelector);
        }

        if(this.view == 'radio')
        {
            this.productVariantSelectors.forEach((element) => {
                if(!this.options[element.dataset.option]){
                    this.options[element.dataset.option] = '';
                }
                element.querySelectorAll('.product-variant-radio-item input').forEach((element) => {
                    element.addEventListener('change', this.selectorChangeEvent.bind(this), false);
                });
            });
        }
        else
        {
            this.productVariantSelectors.forEach((element) => {
                if(!this.options[element.dataset.option]){
                    this.options[element.dataset.option] = '';
                }
                element.addEventListener('change', this.selectorChangeEvent.bind(this), false);
            });
        }        
    }

    selectorChangeEvent(e)
    {
        if(this.view == 'radio'){
            if(e.currentTarget.closest('[data-product-variant-selector]').dataset.option){
                this.options[e.currentTarget.closest('[data-product-variant-selector]').dataset.option] = e.currentTarget.value;
            }
        }else{
            if(e.currentTarget.dataset.option){
                this.options[e.currentTarget.dataset.option] = e.currentTarget.value;
            }
        }

        if(this.productJSONData?.variants)
        {
            let variant_options = [], _option = null;

            for (let option_name of Object.keys(this.options)){
                if(this.view == 'radio'){
                    _option = this.querySelector(`[data-option="${option_name}"] input:checked`);
                }else{
                    _option = this.querySelector(`[data-option="${option_name}"]`);
                }
                if(_option){
                    variant_options.push(_option.value);
                }
            }

            this.productJSONData.variants.forEach((variant) => {
                if(JSON.stringify(variant.options) === JSON.stringify(variant_options))
                {
                    if(window?.history?.pushState && window.location.pathname.match(/\/products\/.+/)){
                        let productUrlWithVariant = window.location.origin + window.location.pathname + '?variant=' + variant.id;
                        window.history.pushState({},'', productUrlWithVariant);
                    }

                    document.dispatchEvent(new CustomEvent('variantChange', {
                        detail: {
                            variant: variant
                        }
                    }));
                }
            });
        }
    }
}

customElements.define('product-variants', ProductVariants);

class ProductPrice extends HTMLElement
{
    constructor()
    {
        super();

        this.urlChange();

        document.addEventListener('variantChange', this.variantChangeEvent.bind(this), false);

        window.addEventListener('URLChange', this.urlChange.bind(this), false);
    }

    variantChangeEvent(e)
    {
        let priceHTML = '';

        if(e.detail?.variant?.price && Shopify?.formatMoney){
            let variantPrice = Shopify?.formatMoney(e.detail.variant.price);
            if(e.detail.variant.price == 0){
                variantPrice = 'FREE';
            }
            priceHTML += `<span class="product-price">${variantPrice}</span>`;
        }

        if(e.detail?.variant?.compare_at_price && Shopify?.formatMoney){
            priceHTML += `<span class="product-price product-price-compare">${Shopify?.formatMoney(e.detail.variant.compare_at_price)}</span>`;
        }

        this.innerHTML = priceHTML;
    }

    urlChange()
    {
        const selling_plan = (new URLSearchParams(location.search)).get('selling_plan');

        if(selling_plan){
            this.classList.add('hidden');
        }else{
           this.classList.remove('hidden'); 
        }
    }
}

customElements.define('product-price', ProductPrice);

class ProductSubscriptionPrice extends HTMLElement
{
    constructor()
    {
        super();

        this.urlChange();

        window.addEventListener('URLChange', this.urlChange.bind(this), false);
    }

    urlChange()
    {
        const selling_plan = (new URLSearchParams(location.search)).get('selling_plan');

        if(selling_plan){
            this.classList.remove('hidden');
        }else{
           this.classList.add('hidden');
        }
    }
}
customElements.define('product-subscription-price', ProductSubscriptionPrice);

class ProductForm extends HTMLElement
{
    constructor()
    {
        super();

        this.buttonLoaderHtml = `
        <span class="loader">
            <svg aria-hidden="true" focusable="false"xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#302d30" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                </circle>
            </svg>
        </span>
        `;

        this.formElement = this.querySelector('form[action="/cart/add"]');

        this.submitButton =  this.formElement?.querySelector('[data-add2cart]');

        this.formId = this.querySelector('input[name=id]');

        this.formElement?.addEventListener('submit', this.submitEvent.bind(this), false);

        document.addEventListener('variantChange', this.variantChangeEvent.bind(this), false);

        this.actionButtonElements = this.querySelectorAll('[data-product-action]');

        this.actionButtonElements?.forEach(el => {
            el.addEventListener('click', this.actionButtonClick.bind(this), false);
        });
    }

    serializeFormData()
    {
        return FormDataJson.toJson(this.formElement);
    }

    submitEvent(e)
    {
        e.preventDefault();

        let formData = this.serializeFormData();
        formData.sections = getSectionsTypes();

        this.submitButton?.setAttribute('disabled', 'disabled');
        this.submitButton?.classList.add('loading');
        this.submitButton?.insertAdjacentHTML('beforeend', this.buttonLoaderHtml);

        fetch('/cart/add.js', {
            body: JSON.stringify(formData),
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'xmlhttprequest'
            },
            method: 'POST'
        }).then(function(response) {
            return response.json();
        }).then(this.submitResponse.bind(this)).catch(function(err) {
            console.error(err);
        });
    }

    submitButtonTimeout()
    {
        if(this.submitButton?.querySelector('span')){
            this.submitButton.querySelector('span').innerHTML = 'Add to cart';
        }
    }

    submitResponse(response)
    {
        this.updateSectionsHtml(response);

        this.submitButton?.removeAttribute('disabled');
        this.submitButton?.classList.remove('loading');
        this.submitButton?.querySelector('.loader')?.remove();
        if(this.submitButton?.querySelector('span')){
            this.submitButton.querySelector('span').innerHTML = 'Added';
        }
        setTimeout(this.submitButtonTimeout.bind(this), 500);

        document.querySelectorAll('product-quick-view dialog')?.forEach(e => e.close());

        const cartDrawer = document.querySelector('cart-update-drawer');
        if(cartDrawer){
            cartDrawer.dispatchEvent(new CustomEvent('render'));
        }

        document.dispatchEvent(new CustomEvent('cartAdd', {
            detail: {
                cart: response
            }
        }));
    }

    updateSectionsHtml(response)
    {
        if(!response){
            return;
        }

        const htmlParser = new DOMParser();

        cartSections.forEach(item => {
            let getSection = null;

            if(response?.sections){
                getSection = response?.sections[item.type] || null;
            }else if(response[item.type]){
                getSection = response[item.type];
            }

            if(getSection)
            {
                const cartSectionDOM = htmlParser.parseFromString(getSection, 'text/html');
                const cartSectionSecondary = cartSectionDOM.querySelector(item?.selector || null);        
                const cartSectionPrimary = document.querySelectorAll(item?.selector || null);
                
                if(item?.customSelector && cartSectionSecondary)
                {
                    if(Array.isArray(item?.customSelector))
                    {
                        item?.customSelector?.forEach(customSelector => {
                            document.querySelectorAll(customSelector)?.forEach(element => {
                                element.innerHTML = cartSectionSecondary.innerHTML;
                            });
                        });
                    }
                    else
                    {
                        document.querySelectorAll(item?.customSelector)?.forEach(element => {
                            element.innerHTML = cartSectionSecondary.innerHTML;
                        });
                    }
                }
                else if(cartSectionPrimary && cartSectionSecondary)
                {
                    cartSectionPrimary?.forEach(item => {
                        item.innerHTML = cartSectionSecondary.innerHTML;
                    });
                }

                if(typeof item?.callBack == 'function'){
                    item.callBack();
                }
            }
        });
    }

    variantChangeEvent(e)
    {
        if(e.detail?.variant?.id)
        {
            if(!this.formElement){
                return;
            }

            const variant = e.detail.variant;

            const btn_label = this.submitButton?.querySelector('.btn-label');

            this.formElement.querySelector('input[name=id]').value = variant.id || 0;

            if(this.submitButton)
            {
                this.submitButton.disabled = !variant.available;

                if(btn_label){
                    btn_label.innerHTML = (variant.available ? 'Add to cart' : 'Sold out');
                }                

                if(variant.available){
                    this.submitButton.classList.add('btn-primary');
                    this.submitButton.type = 'submit';
                }else{
                    this.submitButton.classList.remove('btn-primary');
                    this.submitButton.type = 'button';
                }
            }

            const buyNowButton = this.formElement.querySelector('[data-product-action="buy_now"]');

            if(buyNowButton)
            {
                buyNowButton.disabled = !variant.available;

                if(variant.available){
                    buyNowButton.classList.remove('hidden');
                }else{
                    buyNowButton.classList.add('hidden');
                }
            }
        }

        /*let formBuyBtn = this.formElement.querySelector('[type=submit]');

        if(formBuyBtn)
        {
            formBuyBtn.disabled = (e.detail?.variant?.available === false ? true : false);
        }*/
    }

    actionButtonClick(e)
    {
        e.preventDefault();

        if(e.target.dataset.productAction == 'buy_now')
        {
            window.location.href = `/cart/${this.formId.value}:1`;
        }
    }
}

customElements.define('product-form', ProductForm);

class ProductQty extends HTMLElement
{
    constructor()
    {
        super();

        this.options = {
            min: 1,
            max: -1,
            step: 1
        };

        if(this.dataset.min){
            let minOption = parseInt(this.dataset.min);
            if(minOption > 0){
                this.options.min = minOption;
            }
        }

        if(this.dataset.max){
            let maxOption = parseInt(this.dataset.max);
            if(maxOption > 0){
                this.options.max = maxOption;
            }
        }

        if(this.dataset.step){
            let stepOption = parseInt(this.dataset.step);
            if(stepOption > 0){
                this.options.step = stepOption;
            }
        }

        this.incrementBtn = this.querySelector('[data-qty-plus]');
        this.decrementBtn = this.querySelector('[data-qty-minus]');
        this.inputField = this.querySelector('[data-qty-input]');

        if(this.incrementBtn){
            this.incrementBtn.addEventListener('click', this.incrementEvent.bind(this), false);
        }

        if(this.decrementBtn){
            this.decrementBtn.addEventListener('click', this.decrementEvent.bind(this), false);
        }

        this.value = this.inputField ? parseInt(this.inputField.value) : 1;

        this.querySelector('input[name="quantity"]')?.addEventListener('keyup', e => {
            let keyCode = e.keyCode || e.charCode;
            if(keyCode == 8 || keyCode == 46){
                return false;
            }
            let qty = parseInt(e.target.value);
            qty = !isNaN(qty) ? qty : 1;
            qty = qty > 0 ? qty : 0;
            console.log('qty keyup', qty);
            e.target.value = qty;
        });
    }

    incrementEvent(e)
    {
        e.preventDefault();

        if(!this.inputField){
            return;
        }

        this.value = parseInt(this.inputField.value);

        if(this.options.max > 0 && (this.value + 1) > this.options.max){
            this.value = this.options.max;
        }else{
            this.value++;
        }

        this.inputField.value = this.value;

        this.inputField.dispatchEvent(new InputEvent('change'));
    }

    decrementEvent(e)
    {
        e.preventDefault();

        if(!this.inputField){
            return;
        }

        this.value = parseInt(this.inputField.value);

        if(this.options.min > 0 && (this.value - 1) < this.options.min){
            this.value = this.options.min;
        }else{
            this.value--;
        }

        if(this.value < 1){
            this.value = 1;
        }

        this.inputField.value = this.value;

        this.inputField.dispatchEvent(new InputEvent('change'));
    }
}

customElements.define('product-qty', ProductQty);


class ProductMediaGallery extends HTMLElement
{
    constructor()
    {
        super();

        this.main = this.querySelector('.product-media-gallery-main');
        this.items = this.querySelectorAll('.product-media-gallery-item');

        this.items?.forEach(el => {
            el.addEventListener('click', this.itemClick.bind(this), false);
        });
    }

    itemClick(e)
    {
        e.preventDefault();

        let itemType = e.currentTarget.dataset.type || null;

        if(itemType == 'image')
        {
            if(this.main.querySelector('img')){
                this.main.querySelector('img').src = e.currentTarget.dataset.src;
            }else{
                this.main.innerHTML = `<img src="${e.currentTarget.dataset.src}"/>`;
            }
        }

        if(itemType == 'video')
        {
            let itemVideo = document.createElement('video');
            itemVideo.setAttribute('muted', 'muted');
            itemVideo.setAttribute('controls', 'controls');

            let itemData = JSON.parse(e.currentTarget.dataset.json);

            itemData.sources.map(source => {
                let itemVideoSource = document.createElement('source');
                itemVideoSource.src = source.url;
                itemVideoSource.type = source.mime_type;
                itemVideo.appendChild(itemVideoSource);
            });

            this.main.innerHTML = itemVideo.outerHTML;
        }

        if(itemType == 'model')
        {
            let itemData = JSON.parse(e.currentTarget.dataset.json);

            let itemModel = document.createElement('model-viewer');
            itemModel.setAttribute('camera-controls', 'true');
            itemModel.setAttribute('ar-status', 'not-presenting');
            itemModel.setAttribute('style', '--poster-color:transparent;');
            itemModel.setAttribute('poster', itemData.preview_image.src);
            itemModel.dataset.shopifyFeature = '1.12';
            itemModel.dataset.jsFocusVisible = 'true';

            itemData.sources.map(source => {
                if(source.format == 'glb'){
                    itemModel.setAttribute('src', source.url);
                }
            });

            if(itemModel.hasAttribute('src')){
                this.main.innerHTML = itemModel.outerHTML;
            }
        }

        if(itemType == 'youtube')
        {
            let itemIframe = document.createElement('iframe');
            itemIframe.src = `https://www.youtube.com/embed/${e.currentTarget.dataset.id}`;
            itemIframe.setAttribute('frameborder', '0');
            itemIframe.setAttribute('allowfullscreen', 'allowfullscreen');
            itemIframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');

            this.main.innerHTML = itemIframe.outerHTML;
        }

        if(itemType == 'vimeo')
        {
            let itemIframe = document.createElement('iframe');
            itemIframe.src = `https://player.vimeo.com/video/${e.currentTarget.dataset.id}`;
            itemIframe.setAttribute('frameborder', '0');
            itemIframe.setAttribute('allowfullscreen', 'allowfullscreen');
            itemIframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');

            this.main.innerHTML = itemIframe.outerHTML;
        }
    }
}

customElements.define('product-media-gallery', ProductMediaGallery);

class ProductQuickView extends HTMLElement
{
    constructor()
    {
        super();

        this.button = this.querySelector('button');
        this.dialog = this.querySelector('dialog');

        this.button?.addEventListener('click',  this.onClick.bind(this), false);
        this.dialog?.addEventListener('close', this.onClose.bind(this), false);

        this.section = this.dataset.section;
    }

    load()
    {
        fetch(this.dataset.productUrl + `?sections=${this.section}`, {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'xmlhttprequest'
            }
        }).then(function(response) {
            return response.json();
        }).then(this.getResponse.bind(this)).catch(function(err) {
            console.error(err);
        });
    }

    onClick(e)
    {
        e.preventDefault();
        this.load();
    }

    getResponse(response)
    {
        let mainProductHTML = null;

        if(response?.sections?.hasOwnProperty(this.section)){
            mainProductHTML = response.sections[this.section];
        }else if(response.hasOwnProperty(this.section)){
            mainProductHTML = response[this.section];
        }

        if(mainProductHTML && mainProductHTML.length)
        {
            let mainProductDOMParser = new DOMParser();
            let mainProductDOM = mainProductDOMParser.parseFromString(mainProductHTML, 'text/html');

            this.dialog.querySelector('.dialog-content').innerHTML = mainProductDOM.documentElement.querySelector(`#shopify-section-${this.section}`).innerHTML;
            this.dialog.showModal();
            document.body.classList.add('ovh');
        }
    }

    onClose()
    {
        this.dialog.querySelector('.dialog-content').innerHTML = '';
        document.body.classList.remove('ovh');
    }
}

customElements.define('product-quick-view', ProductQuickView);

class ProductRecommendations extends HTMLElement
{
    constructor()
    {
        super();

        this.product_id = this.dataset.productId ? parseInt(this.dataset.productId) : 0;
        this.limit = this.dataset.limit ? parseInt(this.dataset.limit) : 4;
        this.intent = this.dataset?.intent == 'complementary' ? 'complementary' : 'related';

        if(isNaN(this.limit) || this.limit < 1){
            this.limit = 4;
        }

        this.section_id = 'product-recommendations';

        if(this.product_id){
            this.request();
        }
    }

    request()
    {
        fetch(`/recommendations/products?product_id=${this.product_id}&limit=${this.limit}&intent=${this.intent}&section_id=${this.section_id}`)
        .then(response => response.text())
        .then(this.render.bind(this));
    }

    render(html)
    {
        const domParser = new DOMParser();
        const dom = domParser.parseFromString(html, 'text/html');

        this.innerHTML = dom.getElementById('shopify-section-product-recommendations').innerHTML;

        document.getElementById(this.dataset.displaySectionId).style.display = 'block';

        productQuickViewActionInit();
    }
}

customElements.define('product-recommendations', ProductRecommendations);

class ProductGallery extends HTMLElement
{
    constructor()
    {
        super();

        const thumbsSlider = new Swiper(this.querySelector('.product-gallery-items .swiper'), {
            direction: 'horizontal',
            slidesPerView: 4,
            spaceBetween: 10,
            freeMode: true,
            speed: 800,
            breakpoints: {
                550: {
                    direction: 'vertical',
                }
            }
        });

        const mainSlider = new Swiper(this.querySelector('.product-gallery-main .swiper'), {
            slidesPerView: 1,
            spaceBetween: 10,
            speed: 1000,
            thumbs:{
                swiper: thumbsSlider
            },
            navigation: {
                prevEl: this.querySelector('.product-gallery-main .swiper-button-prev'),
                nextEl: this.querySelector('.product-gallery-main .swiper-button-next')
            }
        });

        this.slider = {
            main: mainSlider,
            thumbs: thumbsSlider
        };

        document.addEventListener('variantChange', this.variantChangeEvent.bind(this), false);
    }

    variantChangeEvent(e)
    {
        const { variant } = e.detail;

        if(variant?.featured_media?.id)
        {
            const productGalleryItems = this.querySelector('.product-gallery-items');

            if(!productGalleryItems){
                return;
            }

            productGalleryItems.querySelectorAll('img')?.forEach((item, index) => {
                if(Number(item.dataset?.id) === Number(variant?.featured_media?.id) && this.slider.thumbs){
                    this.slider.main.slideTo(index);
                }
            });           
        }
    }
}

customElements.define('product-gallery', ProductGallery);